import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '../Modal';
import { CancelButton, MarketDeleteButton } from '../buttons';
import './confirmationModal.css';

/**
 * type: 'delete'
 * With confirmationButtonText (ITEM): buttons read "keep ITEM" / "delete ITEM".
 * Without it: buttons read "cancel" / market delete button with no text.
 *
 * Errors thrown by onConfirm are shown inside the modal and the modal stays open.
 */
export default function DeleteConfirmationModal(_ref) {
  let {
    confirmationButtonText,
    title,
    body,
    cancelText,
    confirmText,
    size,
    onCancel,
    onConfirm
  } = _ref;
  const {
    t
  } = useTranslation();
  const getCancelText = () => {
    if (cancelText) return cancelText;
    return confirmationButtonText ? `${t('keep')} ${confirmationButtonText}` : t('cancel');
  };
  const getConfirmText = () => {
    if (confirmText) return confirmText;
    return confirmationButtonText ? `${t('delete')} ${confirmationButtonText}` : null;
  };
  const renderBody = () => body ?? /*#__PURE__*/React.createElement("p", {
    className: "mb-0"
  }, t('confirm_delete'));
  const renderFooter = _ref2 => {
    let {
      submit,
      loading
    } = _ref2;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CancelButton, {
      onClick: onCancel,
      disabled: loading,
      text: getCancelText()
    }), /*#__PURE__*/React.createElement(MarketDeleteButton, {
      onClick: submit,
      loading: loading
    }, getConfirmText()));
  };
  return /*#__PURE__*/React.createElement(Modal, {
    show: true,
    size: size,
    dialogClassName: "confirmation-modal-dialog",
    dataTestId: 'delete_confirmation_modal',
    title: title ?? t('delete'),
    onHide: onCancel,
    onSubmit: onConfirm,
    renderBody: renderBody,
    renderFooter: renderFooter
  });
}